export const MANAGE = 'manage'; // eslint-disable-line import/prefer-default-export
